"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gtag = _interopRequireWildcard(require("./gtag"));

var _cxThemeInfo = require("../CxStyleDictionary/themes/cxThemeInfo");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable camelcase */
var GA_MEASUREMENT_ID = "G-BY0CYK8117";
/**
 * Evaluate a node to see if it is a cx component
 * If it is a cx component then the callback is called
 * @param node
 * @param callBack
 */

var evaluateNode = function evaluateNode(node, callBack) {
  if (node.attributes) {
    var cx = node.attributes.getNamedItem("cx-component");

    if (cx) {
      callBack(cx);
    }
  }

  if (node.childNodes) {
    node.childNodes.forEach(function (node) {
      return evaluateNode(node, callBack);
    });
  }
};
/**
 * Collects the component name and submits it to analytics
 * @param componentName The component name
 */


var collectCXComponentEvent = function collectCXComponentEvent(componentName) {
  if (!componentName || componentName.length <= 0) {
    return;
  } // check to see if the component was collected before


  var component = window.cxComponentDictionary[componentName];

  if (component) {
    component.count += 1;
    return;
  }

  window.cxComponentDictionary[componentName] = {
    count: 1
  };
  /**
   * Put the cx render event on the queue
   */

  (0, _gtag.default)("event", "render_cx_component", {
    cx_version: _cxThemeInfo.cxuiversion,
    cx_component_name: componentName,
    cx_application_name: document.title || window.location.href
  });
};

var resetDataLayer = function resetDataLayer() {
  window.cxdataLayer.length = 0;
};
/**
 * Installs and initializes the gtag scripts
 * Creates the mutation observer and starts observation
 * Add timer to reset cxdataLayer
 */


var installCxObserver = function installCxObserver() {
  (0, _gtag.install)(GA_MEASUREMENT_ID, {
    page_path: window.location.pathname
  }); // select the target node

  var target = document.querySelector("body"); // create an observer instance

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function (node) {
          return evaluateNode(node, function (attr) {
            return collectCXComponentEvent(attr.value);
          });
        });
      }
    });
  }); // configuration of the observer:

  var config = {
    subtree: true,
    childList: true
  }; // pass in the target node, as well as the observer options

  observer.observe(target, config);
  window.cxComponentDictionary = {};
};

var _default = installCxObserver;
exports.default = _default;